export const formatPrice = (amount) =>
  new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount);

export const formatDate = (ts) =>
  new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(ts));

export const formatTimeAgo = (ts) => {
  const diff = Date.now() - ts;
  const m = Math.floor(diff / 60000);
  if (m < 1) return 'Şimdi';
  if (m < 60) return `${m} dk önce`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} saat önce`;
  const d = Math.floor(h / 24);
  return `${d} gün önce`;
};

export const formatCountdown = (ms) => {
  if (ms <= 0) return '00:00:00';
  const h = Math.floor(ms / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};

export const getReductionProgress = (startPrice, currentPrice, floorPrice) => {
  const total = startPrice - floorPrice;
  const done = startPrice - currentPrice;
  if (total <= 0) return 100;
  return Math.min(100, Math.round((done / total) * 100));
};

export const getRoleBadgeInfo = (role) => {
  const numMap = {
    5: { labelKey: 'roles.admin',     className: 'bg-red-500 text-white' },
    4: { labelKey: 'roles.moderator', className: 'bg-purple-500 text-white' },
    3: { labelKey: 'roles.shop',      className: 'bg-apple-blue text-white' },
    2: { labelKey: 'roles.vip',       className: 'bg-gradient-to-r from-yellow-400 to-orange-400 text-white' },
    1: { labelKey: 'roles.member',    className: 'bg-gray-200 text-gray-600' },
  };
  const strMap = {
    admin:     numMap[5],
    moderator: numMap[4],
    shop:      numMap[3],
    vip:       numMap[2],
    normal:    numMap[1],
  };
  return numMap[role] || strMap[role] || numMap[1];
};

export const getCustomerBadges = (badges) => {
  const map = {
    verified: { labelKey: 'badges.verified', icon: '✓', className: 'bg-green-100 text-green-700' },
    trusted:  { labelKey: 'badges.trusted',  icon: '🛡', className: 'bg-blue-100 text-blue-700' },
    loyal:    { labelKey: 'badges.loyal',    icon: '⭐', className: 'bg-yellow-100 text-yellow-700' },
    admin:    { labelKey: 'badges.admin',    icon: '⚙', className: 'bg-red-100 text-red-700' },
  };
  return (badges || []).map(b => map[b]).filter(Boolean);
};
